import React from "react";
import "@testing-library/jest-dom";
import { render, screen } from "@testing-library/react";
import userEvent from "@testing-library/user-event";
import TranscriptSourcePicker from "./TranscriptSourcePicker";
import type { Transcript } from "../../types/transcripts";

const makeTranscript = (transcriptId: number, title: string): Transcript => ({
  transcript_id: transcriptId,
  title,
  status: "Completed",
  visibility: "Private",
  language: "en",
  created_by_user_id: "current-user",
  created_date: "2026-10-20T12:00:00Z",
  modified_date: "2026-10-20T12:00:00Z",
  segments: [],
});

describe("TranscriptSourcePicker", () => {
  it("opens the loaded options on mouse focus and selects an option by mouse", async () => {
    const user = userEvent.setup();
    const transcripts: Transcript[] = [
      makeTranscript(1, "Private meeting notes"),
      makeTranscript(2, "Private customer interview"),
      makeTranscript(3, "Private planning session"),
      { ...makeTranscript(4, "In-progress recording"), status: "Processing" },
    ];
    const onSelect = jest.fn();

    render(
      <TranscriptSourcePicker
        transcripts={transcripts}
        value={null}
        disabled={false}
        loading={false}
        onSearchChange={jest.fn()}
        onSelect={onSelect}
      />,
    );

    await user.click(screen.getByRole("combobox"));

    const option = await screen.findByRole("option", {
      name: /Private customer interview/,
    });
    expect(option).toHaveStyle({ paddingLeft: "12px", paddingRight: "12px" });
    expect(screen.getByRole("listbox")).toHaveAttribute(
      "data-popper-placement",
      "top-start",
    );
    expect(screen.getAllByRole("option")).toHaveLength(3);
    expect(
      screen.queryByRole("option", { name: /In-progress recording/ }),
    ).not.toBeInTheDocument();
    await user.click(option);

    expect(onSelect).toHaveBeenCalledWith(transcripts[1]);
  });
});
